import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import APIKeys from "./APIKeys";
import APIKeyUsages from "./APIKeyUsages";
import useSubscription from "../../hooks/useSubscription";
import { Navigate } from "react-router-dom";

const dummyUsages = [
  {
    "endpoint": "/api/scorm-files/upload/",
    "success": 25,
    "failure": 3,
    "total": 28
  },
  {
    "endpoint": "/api/content-extractions/",
    "success": 12,
    "failure": 1,
    "total": 13
  }
];

const ApiIntegration = () => {
  const [activeTab, setActiveTab] = useState("keys");
  const { isTrial, isActive } = useSubscription();

    // Redirect to pricing if Trial or inactive subscription
    if (isTrial || !isActive) {
        return <Navigate to="/pricing" replace />;
    }

  return (
    <div className="container py-4 border">
      <ToastContainer />
      <h3 className="fw-semibold mb-4">API Integration</h3>
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "keys" ? " active" : ""}`}
            onClick={() => setActiveTab("keys")}
          >
            <i className="bi bi-key-fill me-1"></i> API Keys
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "usages" ? " active" : ""}`}
            onClick={() => setActiveTab("usages")}
          >
            <i className="bi bi-graph-up me-1"></i> API Key Usages
          </button>
        </li>
      </ul>
      <div className="tab-content my-5 ">
        <div className={`tab-pane fade${activeTab === "keys" ? " show active" : ""}`}>
          {activeTab === "keys" && <APIKeys />}
        </div>
        <div className={`tab-pane fade${activeTab === "usages" ? " show active" : ""}`}>
          {activeTab === "usages" && <APIKeyUsages usages={dummyUsages} />}
        </div>
      </div>
    </div>
  );
};

export default ApiIntegration; 